import React, { Component } from 'react';

import AppContent from '../shared/AppContent';
import {AuthContext} from "../../authContext";
import BreadcrumbSeparator from "../shared/BreadcrumbSeparator";
import CategoryDisplay from "./CategoryDisplay";
import Flex from "../shared/Flex";
import Loading from "../shared/Loading";
import WebLink from "../shared/WebLink";

class HelpCategory extends Component {
  static contextType = AuthContext;
  state = {
    isLoading: true,
    id: null,
    title: "",
    articles: ""
  };
  componentDidMount = async () => {
    console.log("HelpCategory > componentDidMount > props", this.props)
    if (this.props.helpData) {

      let category = this.props.helpData.getCategoryByID(this.props.match.params.id);

      await this.setState({
        isLoading: false,
        id: category.id,
        title: category.name,
        articles: category.articles
      });
    }
  };
  render() {
    if (this.state.isLoading) {
      return (
        <Loading />
      )
    } else {
      return (
        <AppContent>
          <Flex style={{justifyContent:"flex-start", marginBottom:"10px"}}>
            <div>
              <WebLink onClick={() => this.context.navigate(`/help`)}>Help</WebLink><BreadcrumbSeparator />
            </div>
            <div>
              {this.state.title}
            </div>
          </Flex>
          <CategoryDisplay title={this.state.title} articles={this.state.articles} />
        </AppContent>
      );
    }
  }
}

export default HelpCategory;
